var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStreet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.758,
    height: 10.555,
    viewBox: "0 0 23.758 10.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#353841;stroke-linecap:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6172.522,9218.057H6194.4",
    transform: "translate(-6172.522 -9218.057)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6172.522,9218.057H6194.4",
    transform: "translate(-6172.522 -9209.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6172.522,9218.057h3.047",
    transform: "translate(-6172.522 -9213.529)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6172.522,9218.057h3.047",
    transform: "translate(-6166.118 -9213.529)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6172.522,9218.057h3.047",
    transform: "translate(-6159.714 -9213.529)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6172.522,9218.057h3.047",
    transform: "translate(-6153.311 -9213.529)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreet);
export default __webpack_public_path__ + "static/media/street.255881da565b88e1a1210f378f1224f6.svg";
export { ForwardRef as ReactComponent };